import React from 'react';
import { MailIcon, PhoneIcon, ShoppingBagIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-12" data-id="element-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-18">
          <div data-id="element-19">
            <div className="flex items-center gap-2 mb-4" data-id="element-20">
              <ShoppingBagIcon className="w-8 h-8 text-green-400" data-id="element-21" />
              <span className="text-2xl font-bold" data-id="element-22">Lola</span>
            </div>
            <p className="text-gray-400" data-id="element-23">
              Simplifying therapeutic diet management for healthcare teams and
              patients.
            </p>
          </div>

          <div data-id="element-24">
            <h3 className="font-bold text-lg mb-4" data-id="element-25">For Healthcare</h3>
            <ul className="space-y-2 text-gray-400" data-id="element-26">
              <li data-id="element-27">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-28">
                  RDN Teams
                </a>
              </li>
              <li data-id="element-29">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-30">
                  Hospital Systems
                </a>
              </li>
              <li data-id="element-31">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-32">
                  Case Studies
                </a>
              </li>
              <li data-id="element-33">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-34">
                  Request Demo
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-35">
            <h3 className="font-bold text-lg mb-4" data-id="element-36">Resources</h3>
            <ul className="space-y-2 text-gray-400" data-id="element-37">
              <li data-id="element-38">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-39">
                  How It Works
                </a>
              </li>
              <li data-id="element-40">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-41">
                  Patient Guide
                </a>
              </li>
              <li data-id="element-42">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-43">
                  Support
                </a>
              </li>
              <li data-id="element-44">
                <a href="#" className="hover:text-green-400 transition-colors" data-id="element-45">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-46">
            <h3 className="font-bold text-lg mb-4" data-id="element-47">Contact</h3>
            <ul className="space-y-3 text-gray-400" data-id="element-48">
              <li className="flex items-center gap-2" data-id="element-49">
                <MailIcon className="w-5 h-5 text-green-400" data-id="element-50" />
                <a href="mailto:hello@lola.health" className="hover:text-green-400 transition-colors" data-id="element-51">
                  hello@lola.health
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-52">
                <PhoneIcon className="w-5 h-5 text-green-400" data-id="element-53" />
                <a href="tel:+1234567890" className="hover:text-green-400 transition-colors" data-id="element-54">
                  (123) 456-7890
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400" data-id="element-55">
          <p data-id="element-56">&copy; 2024 Lola Health. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}